module.exports = __webpack_public_path__ + "static/media/check-blue.b9f9623a.svg";